import React, { useContext, createContext } from "react";
import axiosFactory, { METHOD_POST } from "../helpers/AxiosFactory";
import {
  GET_BLOG_BY_ID,
  GET_BLOGS_BY_FILTERS,
  GET_BLOGS_LISTING,
  GET_BLOG_SIBLINGS,
  GET_BLOG_RELATED,
  GET_BLOG_CATEGORY,
  GET_BLOG_CATEGORIES,
} from "../helpers/UrlConstants";
const BlogContext = createContext();
export function useBlogContext() {
  return useContext(BlogContext);
}
export default function BlogProvider({ children }) {
  async function getBlogsById(data) {
    return await axiosFactory({
      url: GET_BLOG_BY_ID,
      method: METHOD_POST,
      data: data,
    });
  }
  async function getBlogsByFilter(data) {
    return await axiosFactory({
      url: GET_BLOGS_BY_FILTERS,
      method: METHOD_POST,
      data: data,
    });
  }
  // One page of the magazine listing, as the server renders it.
  async function getBlogsListing(data) {
    return await axiosFactory({
      url: GET_BLOGS_LISTING,
      method: METHOD_POST,
      data: data,
    });
  }
  // Internal links (src/seo/content.js on the API).
  async function getBlogSiblings(data) {
    return await axiosFactory({ url: GET_BLOG_SIBLINGS, method: METHOD_POST, data });
  }
  async function getBlogRelated(data) {
    return await axiosFactory({ url: GET_BLOG_RELATED, method: METHOD_POST, data });
  }
  async function getBlogCategory(data) {
    return await axiosFactory({ url: GET_BLOG_CATEGORY, method: METHOD_POST, data });
  }
  async function getBlogCategories(data) {
    return await axiosFactory({ url: GET_BLOG_CATEGORIES, method: METHOD_POST, data });
  }
  const value = {
    getBlogsById,
    getBlogsByFilter,
    getBlogsListing,
    getBlogSiblings,
    getBlogRelated,
    getBlogCategory,
    getBlogCategories,
  };
  return <BlogContext.Provider value={value}>{children}</BlogContext.Provider>;
}
